define('services/reverseGeocode/reverseGeocodeBase',["rest/reverseGeocode", "model/reverseGeocode/reverseGeocode", "../chain", "../validators", "../converters",
    "../utils"], function (reverseGeocode, model, chain, validators, converters, utils) {
    "use strict";

    var TYPES = {
        reverseGeocode: "reverseGeocode",
        crossStreetLookup: "reverseGeocode/crossStreet"
    }, fields = {
        key: {
            validator: validators.string
        },
        position: {
            converter: converters.point,
            validator: validators.point,
            required: true
        },
        spatialKeys: {
            validator: validators.bool
        },
        heading: {
            validator: validators.number
        },
        radius: {validator: validators.naturalInteger},
        protocol: {validator: validators.oneOfValue(["http", "https"], "protocol")},
        baseUrl: {validator: validators.string},
        serviceUrl: {validator: validators.string}
    };

    function ReverseGeocodeBase(options) {
        this.options = options;
        this.defaultFields = utils.clone(fields);
        this.fields = {};
    }

    ReverseGeocodeBase.prototype.TYPE = TYPES;
    ReverseGeocodeBase.prototype.construct = function () {
        var mergedFields = utils.addFields.call(this, this.fields);
        return chain.call(this, mergedFields, this.handleChain, this.options);
    };
    ReverseGeocodeBase.prototype.handleChain = function (data, callback) {
        reverseGeocode.reverseGeocode(data, function (response) {
            callback.call(this, model(response)[0]);
        });
    };

    function reverseGeocodeConstructor(options) {
        return (new ReverseGeocodeBase(options)).construct();
    }

    reverseGeocodeConstructor.prototype.constructor = ReverseGeocodeBase;

    return reverseGeocodeConstructor;
});

